import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/6.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';

import ict1 from '../assets/photos/ict_solutions/1.jpg';
import ict2 from '../assets/photos/ict_solutions/2.jpg';
import ict3 from '../assets/photos/ict_solutions/3.jpg';
import ict4 from '../assets/photos/ict_solutions/4.jpg';
import ict5 from '../assets/photos/ict_solutions/5.jpg';
import ict6 from '../assets/photos/ict_solutions/6.jpg';
import ict7 from '../assets/photos/ict_solutions/7.jpg';
import ict8 from '../assets/photos/ict_solutions/8.jpg';
import ict9 from '../assets/photos/ict_solutions/9.jpg';
import ict10 from '../assets/photos/ict_solutions/10.jpg';
import ict11 from '../assets/photos/ict_solutions/11.jpg';
import ict12 from '../assets/photos/ict_solutions/12.jpg';
import ict13 from '../assets/photos/ict_solutions/13.jpg';
import ict14 from '../assets/photos/ict_solutions/14.jpg';
import ict15 from '../assets/photos/ict_solutions/15.jpg';
import ict16 from '../assets/photos/ict_solutions/16.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											ICT PRODUCTS AND SECURITY SOLUTIONS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={ict_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									JIEZHI TECH CO LTD stands at the forefront as a premier provider of integrated Information and Communications Technology (ICT) products and cutting-edge security solutions. Leveraging our extensive experience and formidable partnerships with industry-leading manufacturers, we offer a comprehensive array of advanced equipment and supplies to meet diverse technological needs.
								</h6>

								<HorizontalImageStrip
									images={[ict1, ict2, ict3, ict4, ict5]}
								/>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									COMPUTERS, SERVERS, SCANNERS, AND PRINTERS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict15}
								/>	


								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer a diverse selection of high-performance computers, servers, scanners, and printers from trusted brands, catering to the varying needs of businesses and organizations.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									LAPTOPS, MONITORS, AND MEMORY
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict1}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our range of laptops, monitors, and memory solutions provides the flexibility, performance, and reliability required in today’s fast-paced digital landscape.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									ADVANCED LED PRODUCTS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict8}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our advanced LED products, including displays and lighting solutions, offer energy efficiency, superior image quality, and versatile applications across industries.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									DIGITAL SIGNAGE AND VIDEO WALLS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict10}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We provide state-of-the-art digital signage and video wall solutions that enable dynamic and engaging visual communication in various settings, from retail spaces to corporate environments.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									CAMERAS AND CAMCORDERS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict12}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer a comprehensive range of cameras and camcorders that cater to professional photography, videography, and surveillance needs.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									NETWORK APPLIANCES AND UPS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict6}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our network appliances and Uninterruptible Power Supply (UPS) systems ensure reliable and secure network infrastructure, protecting critical data and minimizing downtime.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									CABLES AND IT CONSUMABLES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict13}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We provide a wide variety of high-quality cables and IT consumables, including network cables, power cords, and printer supplies, ensuring smooth and uninterrupted operations.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									ELECTRONIC BACKUP DEVICES AND SURGE PROTECTORS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict4}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our electronic backup devices and surge protectors safeguard valuable data and equipment from potential losses or damage caused by power fluctuations or outages.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SECURE STORAGE SYSTEMS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict4}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer secure storage systems that protect sensitive data and ensure compliance with industry regulations and data protection standards.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SOFTWARE SOLUTIONS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict9}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our software solutions encompass a range of applications, from productivity tools to specialized industry-specific software, enabling businesses to streamline processes and enhance efficiency.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									CCTV CAMERAS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict14}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our state-of-the-art CCTV (Closed-Circuit Television) cameras provide high-quality video surveillance, enabling customers to monitor their premises remotely and deter potential security threats. With features such as night vision, motion detection, and cloud storage, our CCTV solutions offer unparalleled security and convenience.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SMART AND HOTEL DOOR LOCKS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict16}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer a range of innovative smart door locks and hotel door locks that combine advanced technology with elegant design. Our smart locks allow users to control access to their homes or businesses using their smartphones, while our hotel door locks provide secure and efficient room access management for the hospitality industry.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									ACCESS CONTROL SYSTEMS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ict2}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our cutting-edge access control systems enable businesses to manage and monitor entry and exit points, restrict access to sensitive areas, and maintain a secure environment. With features such as biometric authentication, card readers, and remote management, our access control solutions are tailored to meet the unique security needs of various industries.
								</h6>
							</div>
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}